module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.SitePage_Login":{"widgets.loginForm.hooks.onReport":[{"value":function (response) {
fox.wom.selectFirst('~.Site_Footer').reportProblem();
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101006},"path":"~.SitePage_Login","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/options/sitepage/login.js
// module id = 674
// module chunks = 4